import type { Answer, SubmittedRawInput } from "@memorang/types";

export const getSubmittedRawInput = (
	answer?: Answer | null,
): SubmittedRawInput | undefined => {
	const submitted = answer?.userSubmittedAnswer;

	if (typeof submitted !== "object" || submitted === null) {
		return undefined;
	}

	const { rawInput } = submitted;

	if (rawInput?.value == null || rawInput.value.trim() === "") {
		return undefined;
	}

	return rawInput;
};

export const getSubmittedRawInputValue = (
	answer: Answer | null | undefined,
	inputType: SubmittedRawInput["inputType"],
): string | undefined => {
	const rawInput = getSubmittedRawInput(answer);
	return rawInput?.inputType === inputType ? rawInput.value : undefined;
};
